import { memo, ReactNode } from 'react';
import "./RoundedCard.scss";

function MemoComponent(
  { className, children }:
  { className?: string, children: ReactNode}
) {
  return (
    <div className={`rounded-card ${className}`}>
      {children}
    </div>
  )
};

export const RoundedCard = memo(MemoComponent);